(function ($) {
  $(window).on("load", function () {
    if ($("body").hasClass("single-clinical-research")) {
      if ($(".related-research-module").length > 0) {
        $(".related-research-module").each(function () {
          let $module = $(this);

          $module.find(".related-research-cards.slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            prevArrow: $module.find(".slick-prev"),
            nextArrow: $module.find(".slick-next"),
            infinite: false,
            speed: 500,
            cssEase: "linear",
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });

          $(".related-research-cards.slider .slick-dots button").attr(
            "tabindex",
            0
          );
        });
      }
    }
  });
})(jQuery);
